export const TranslationsBG = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "Поръчай Онлайн",
        cart: "Количка",
        open_24: "24 Часа",
        closed: "Затворено",
        free: "С БЕЗПЛАТНА ДОСТАВКА",
        something_went_wrong: "имахме малък проблем",
        try_again: "опитай отново",
    },
    constants: {
        calendar: {
            days: {
                monday: "Понеделник",
                tuesday: "Вторник",
                wednesday: "Сряда",
                thursday: "Четвъртък",
                friday: "Петък",
                saturday: "Събота",
                sunday: "Неделя",
            },
        },
        services: {
            delivery: "С доставка",
            pickup: "Ще взема сам",
            dine_in: "Поръчка до маса",
            table_booking: "Резервация на маса",
        },
        payment: {
            method: {
                cash: "Плащане при доставка",
                card: "Плащане с карта",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "CardConnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Custom",
            },
            backend_method: {
                cash: "Плащане при доставка",
                card: "Плащане с карта",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "CardConnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Custom",
            },
            status: {
                success: "Плащането е успешно",
                pending: "Обработваме плащането",
                error: "Отказана транзакция",
                refunded: "Върнато плащане",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "Премахни",
                drop_here: "Плъзни с мишката твоите файлове тук или натисни за да избереш един",
                accepts: "Приемам {{fileTypes}} файла",
                errors: {
                    max_files: "Максимално до {{number}} броя файлове са позволени",
                    max_size: "Максималния размер на един файл е {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "В момента не приемаме повече поръчки за хапване на място. Можете да опитате да поръчате за по-късна дата и час",
            },
            buttons: {
                order: {
                    book_order: "Резервирай маса / Поръчай",
                    order_online: "Поръчай Онлайн",
                    book_table: "Резервирай Маса",
                    order: "Поръчай сега",
                    book: "Резервирай сега",
                    cart: "Преглед на поръчка",
                    restart: "Изтрий",
                    closed: "В момента е затворено",
                    not_accepting: "Не Приемаме Повече Поръчки за Днес",
                },
            },
        },
        modals: {
            auth: {
                login: "Вход",
                register: "Регистрация",
                register_commence: "Напред",
                register_complete: "Създай нов профил",
                register_confirmation_sent: "Изпратен е код за потвърждение на вашия и-мейл. Моля, въведете го по-долу, за да продължите",
                register_confirmation_resent: "Кодът за потвърждение е изпратен отново, проверете папка спам във вашия и-мейл, ако кода продължава да липсва се регистрирайте с Facebook или Google",
                register_restart: "Започни отначало",
                register_resend_code: "Изпрати отново кода",
                login_placeholder: "И-мейл",
                password_placeholder: "Парола",
                confirm_password_placeholder: "Потвърди парола",
                confirmation_code_placeholder: "Въведи кода за потвърждение на и-мейл",
                accept_terms: "Приемам Общите условия",
                accept_terms_view: "Виж",
                login_facebook: "Продължи с Facebook",
                login_google: "Продължи с Google",
                benefits: "Вход или създаване на профил за да следиш поръчките и резервациите си, плащай и с отстъпка",
                logged_in: "Влезнахте успешно в профила си",
                logged_out: "Отписване",
                password_reset: {
                    init_button: "Изпрати ми Парола за Възстановяване на И-мейла",
                    init_success: "Линкът за възстановяване на паролата беше изпратен на и-мейла",
                    complete_button: "Възстановяване на парола",
                    complete_success: "Успешно променихте паролата, впишете се с новата ви парола",
                    forgot_password_text: "Забравихте вашата парола? ",
                    forgot_password_link: "Възстановяване на парола",
                    remember_password_text: "Запомнихте ли паролата си? ",
                    remember_password_link: "Назад",
                    invalid_title: "Промяната на паролата е неуспешно",
                    invalid_description: "Невалиден е линкът за възстановяване на паролата, пробвайте с нов линк",
                    invalid_link: "Вписване",
                    title: "Възстановяване на парола",
                    description: "Въведете новата парола за вашия профил",
                },
                error_generic: "Засякохме, че нещо не е наред, опитайте отново, а ако не успеете, свържете се с поддръжката",
                error_accept_terms: "Моля приемете общите условия",
                error_password_length: "Минимална дължина за парола е поне 6 символа",
                error_social: "Нещо се обърка, опитай отново или се свържи с поддръжката",
                error_confirmation_code: "Невалиден код за потвърждение",
                error_invalid_code: "Невалиден код за потвърждение",
                error_exists: "Този потребител вече е регистриран",
                error_invalid_email_pass: "Невалидна парола или имейл адрес",
                error_password_no_match: "Паролите се различават една от друга",
                error_user_not_found: "Няма потребител с този и-мейл адрес",
                error_invalid_email: "Невалиден и-мейл адрес",
                error_invalid_reset_token: "Невалиден линк за възстановяване, пробвайте с нов",
            },
            booking: {
                form: {
                    name: "Име и Фамилия",
                    email: "И-мейл",
                    phone: "Телефонен номер",
                    number_of_people: "Брой гости",
                    number_of_people_max: "Максимален брой гости ({{max_people}} Max)",
                    number_of_people_min: "Минимален брой гости ({{min_people}} Min)",
                    number_of_people_max_min: "Брой гости от (Between {{min_people}} до {{max_people}})",
                    notes: "Специални предпочитания / За поводи, изненади",
                    submit: "Резервирай маса сега",
                    email_optional: "(по избор)",
                    date: "Дата",
                    duration: "Продължителност",
                    seating: "Свободни часове",
                    number_of_guests: "Брой гости",
                    notes_placeholder: "Алергии, повод, предпочитание за място",
                    reserving: "Резервиране...",
                    reserve_table: "Резервирай маса",
                    please_choose_a_date_and_time: "Изберете дата и час.",
                    invalid_people: "Броят гости трябва да е между {{min}} и {{max}}.",
                    party_size_max_fallback: "позволения максимум",
                    loading_available_times: "Зареждане на свободните часове…",
                    select_a_date_to_see_available_times: "Изберете дата, за да видите свободните часове.",
                    no_times_available_for_this_date: "Няма свободни часове за тази дата. Изберете друг ден.",
                    shift: "Смяна",
                    service_times: "Работно време",
                    new_shift: "Нова смяна",
                    time: "час",
                    times: "часа",
                    unavailable: "Недостъпно",
                    available: "Достъпно",
                    required_name: "Въведете името си.",
                    required_phone: "Въведете телефонния си номер.",
                    required_email: "Въведете имейл адреса си.",
                    invalid_email: "Въведете валиден имейл адрес.",
                    required_terms: "Приемете условията преди да резервирате.",
                    missing_custom_fields: "Отговорете на всички задължителни въпроси.",
                    reservation_is_unavailable: "Резервацията не е достъпна.",
                    please_contact_the_restaurant_directly: "Свържете се директно с ресторанта.",
                    almost_done: "Почти готово",
                    your_details: "Вашите данни",
                    tell_us_who_s_coming: "Кажете ни кой идва, за да потвърдим резервацията ви.",
                    book_your_table: "Резервирайте масата си",
                    choose_a_time_that_works_for_you: "Изберете час, който ви устройва.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "Изпратете заявката за резервация и ресторантът ще се погрижи за останалото.",
                    select_date: "Изберете дата",
                    standard: "Стандартно",
                    minutes: "минути",
                    next: "Напред →",
                    back: "← Назад",
                    accept_terms: "Приемам общите условия.",
                    info_1: "Очаквайте известие на вашия имейл до минути ще бъде разгледана резервацията ви, за което бързо ще ви уведомим, че е ПОТВЪРДЕНА или ОТКАЗАНА с мотив",
                },
                errors: {
                    not_found: "Не откриваме резервацията в нашите записи. Моля направете двойна проверка и дали не е възможно също да е била изтрита, ако не я откриете се свържете с нас. С радост ще помогнем",
                    generic: "Имахме някакъв малък проблем. Моля обновете страницата, ако проблема продължава се свържи с поддръжката ни",
                    something_went_wrong: "Имахме някакъв малък проблем",
                    accept_terms: "Моля приемете общите ни условия за ползване",
                    required_phone: "Въведете вашия телефонен номер",
                    required_email: "Въведете вашия и-мейл",
                    required_name: "Въведете вашето име",
                    invalid_email: "Въведете имейла си във формат: name@example.com",
                    invalid_phone: "Въведете телефона си във формат: +359877000222",
                    invalid_people: "Заявеният брой гости е по-голям от капацитета на масата",
                    booking_capacity_threshold: "За този час сме напълно заети. Опитайте друг час.",
                    slot_unavailable: "За този брой гости сме напълно заети. Опитайте друг час.",
                    booking_date_paused: "Резервациите за тази дата са спрени. Изберете друг ден.",
                    invalid_table_assignment: "Тези маси не побират компанията ви. Изберете друг час.",
                    exceeded_order_limit: "Твърде много заявки за резервация. Опитайте по-късно.",
                    validation_failed_recaptcha_v3: "Открит е необичаен трафик. Използвате ли VPN? Завършете проверката по-горе и опитайте отново.",
                    validation_failed_recaptcha_v2: "Резервацията не можа да започне. Опитайте отново или използвайте друг начин. Ако използвате VPN, първо го изключете.",
                    booking_already_exists: "Тази резервация вече е изпратена. Проверете имейла си или отворете връзката към резервацията.",
                    invalid_party_size: "Изберете валиден брой гости.",
                    invalid_request: "Невалидна заявка. Обновете страницата и опитайте отново.",
                    table_booking_unavailable: "Резервацията на маса не е достъпна.",
                },
            },
            cart: {
                title: "Преглед на поръчка",
                proceed_to_checkout: "Продължи",
                edit_dish: "Редактирай",
                remove_dish: "Премахни",
                no_items_1: "Няма добавени продукти от менюто за поръчка",
                no_items_2: "Добави продукти сега",
                free_delivery_notice: "ВКЛЮЧЕНА БЕЗПЛАТНА ДОСТАВКА за поръчки над {{value, currency}}",
                errors: {
                    min_order_promo: "Изисква се минималната стойност на поръчката да бъде над {{value, currency}} за ПРОМО КОДА да бъде приложен",
                    min_order_delivery: "Минималната стойност на поръчката е {{value, currency}} за да бъде извършена доставка до адрес",
                },
                promo: {
                    heading: "Промо Код",
                    placeholder: "Въведи промо код",
                    add: "Добави кода",
                    title: "Промо {{name}} е добавен в поръчката",
                    fixed_discount: "{{value, currency}} ОТСТЪПКА",
                    percent_discount: "{{value}}% ОТСТЪПКА",
                    added_to_cart: "Промо кода е приложен към поръчката",
                    errors: {
                        not_found: "Промо кода е невалиден",
                        disabled: "Промо кода е изтекъл",
                        not_available: "Промо кода не е наличен",
                        logged_in_only: "Трябва да се впишете за да може да използвате промо кода",
                        already_used: "Вие вече сте използвали този промо код",
                        invalid: "Този промо код повече не е валиден",
                        invalid_service: "Този промо код не е валиден за избраната услуга",
                        later_only: "ВАЛИДЕН е само за предварителни поръчки",
                        now_only: "ВАЛИДЕН единствено за поръчки с изпълнение на момента, а не за поръчки с по-късен час на изпълнение",
                        generic: "Oопа...засякохме, някаква грешка и същата вече е регистрирана за проверка",
                        dishes_required_multi: "Този промо код с отстъпка се прилага когато определени ястия или продукти се добавят към вашата поръчка",
                        dishes_required_single: "Този промо код с отстъпка се прилага само за '{{dish}}'",
                    },
                },
                tip: {
                    title: "Бакшиш",
                    placeholder: "Добави бакшиша",
                },
            },
            checkout: {
                title: "Информация за теб",
                subtitle: "Потвърди детайлите по поръчката",
                details: {
                    service: "Услуги",
                    due: "Заявка за",
                    due_now_asap: "Сега / Веднага",
                    address: "Адрес на доставка",
                    total: "ОБЩО",
                    table: "Маса",
                    store_location: "Store Address",
                },
                customer: {
                    title: "Потребител",
                    subtitle: "Влез за да следиш поръчки & резервации",
                    button: "Вход",
                    name: "Име и фамилия",
                    email: "И-мейл адрес",
                    phone: "Телефонен номер",
                    phone_important: "Телефонен номер (Важно)",
                    notes: "Специални предпочитания към поръчка",
                    delivery_notes: "Инструкция за доставка / Бележки към поръчка",
                },
                payment: {
                    title: "Как ще платите",
                },
                accept_terms: "Приемам Общите условия",
                accept_terms_view: "Преглед",
                processing_order: "Поръчай сега",
                warning: {
                    different_payment_currency: "Цените на заведението са в {{store_currency}} валута, като платежния метод е в {{payment_currency}}",
                    closing_soon: "Затваряме скоро, приемаме само последните поръчки направени в следващите {{value}} минути",
                    closed: "За съжаление, приключихме за днес и повече поръчки няма да бъдат приемани",
                    expired: "Приключихме с поръчките в избраното време. Моля изберете по късна дата и час",
                },
                errors: {
                    stripe_generic: "Кредитната карта даде грешка, опитайте отново или се върнете назад",
                    stripe_loading_fail: "Грешка при зареждане на формуляр за плащане, опитай отново",
                    something_went_wrong: "Нещо не е наред",
                    paypal_generic: "Нещо се обърка с PayPal, опитайте отново или изберете друг метод на плащане",
                    payment_fail: "Плащането е неуспешно, моля, опитайте отново или изберете друг метод на плащане",
                    payment_cancelled: "Плащането е отменено, моля, опитайте отново или изберете друг метод на плащане",
                    payment_error: "Грешка при обработката на онлайн плащането, опитайте отново или изберете друг метод на плащане",
                    payment_declined: "Вашият метод на плащане беше отхвърлен",
                    card_declined: "Вашата карта беше отхвърлена и плащането не можа да бъде обработено",
                    promo_max_uses_exceeded: "Този промо код достигна лимита си за използване и вече не е наличен.",
                    store_closed: "Заведението е затворено и вече не приема поръчки",
                    accept_terms: "Моля, приемете общите условия",
                    required_payment: "Изберете начин на плащане",
                    required_phone: "Въведете телефонен номер",
                    required_email: "Въведете своя имейл",
                    required_name: "Вашето име и фамилия",
                    invalid_email: "Моля, въведете валиден имейл адрес",
                    invalid_phone: "Моля, въведете валиден телефонен номер",
                    invalid_cc_number: "Номерът на вашата кредитна карта е невалиден",
                    retry_cc_number: "Нещо се обърка, въведете отново номера на кредитната си карта и опитайте отново",
                    closed: "Заведението е затворено/затваря и не приема поръчки",
                    promo_login_required: "Трябва да сте влезли, за да използвате тази промоция",
                    promo_used: "Вече се възползвахте от тази промоция",
                },
                button: {
                    continue: "ПРОДЪЛЖИ КЪМ ПЛАЩАНЕ",
                    place_order: "ПОРЪЧАЙ СЕГА",
                },
            },
            customer: {
                age_v: {
                    title: "Проверка на възрастта ти",
                    required_for_items: "Изисква се за поръчка на определени продукти",
                    min_age: "Минимална възраст е: {{age}} години",
                    est_time: "В повечето случаи времето за проверка е не повече от: {{time}} часа",
                    upload_description: "Приложете, като качите вашия документ за самоличност по-долу за проверка. Ще бъдете уведомени по имейл след потвърждение. Качете до 2 изображения, като всяко трябва да е с максимален размер до 2 MB",
                    pending_description_1: "Успешно изпратихте документите си. Ще бъдете уведомени по имейл, когато бъдете одобрени",
                    pending_description_2: "Обновете страницата, за да актуализирате състоянието си на потвърждение. В повечето случаи времето за проверка е не повече {{time}} часа",
                    approved_description: "Честито. Вашият акаунт е потвърден, че отговаря на критерия за възраст. Вече можете да поръчате от менюто продукти, които са ограничени",
                    rejected_description: "Имахме малък проблем с вашият документ за самоличност, за което е отхвърлен. Ако искате да опитате отново, моля, изпратете ни селфи с вашия документ и негова сниманка в цялост",
                    upload: "Качване",
                    reupload: "Повторно качване на документи",
                    go_back: "Назад",
                    view_document: "Преглед на документа {{number}}",
                    status: {
                        unverified: "Непотвърден",
                        pending: "В очакване на одобрение",
                        approved: "Успешно потвърден",
                        rejected: "Отхвърлен",
                    },
                },
                headings: {
                    sessions: "Посещения",
                    orders: "Поръчки",
                    spend: "Общо всичко",
                    order_history: "История на поръчките",
                },
            },
            custom_payment: {
                title: "{{name}} метод за плащане",
                description: "Достигнахте нашата онлайн форма за плащане. Моля, попълнете полетата по-долу, за да извършите плащане. Ако не е въведена сумата, вашите данни ще бъдат запазени, но няма да бъдете таксувани.",
                disabled: "Страницата за онлайн плащане не е конфигурирана правилно. Моля, свържете се със собственика на сайта, за да отстрани проблема",
                success: "Плащането на сметката ви е успешно. Заповядайте отново",
                back: "Към менюто за поръчки",
                fields: {
                    name: "Име и фамилия",
                    email: "И-мейл",
                    reference: "Референция на плащане.",
                    amount: "Стойност ($)",
                    name_on_card: "Имена на картодържателя",
                    submit: "Плати поръчката сега",
                },
                warning: {
                    currency: "Забележка: Сумата на плащането е в {{actual}}, а не в {{default}}",
                },
                errors: {
                    generic: "Имахме малък проблем, моля пробвайте отново или се свържете с нас",
                    stripe_generic: "Има проблем с кредитната карта, опреснете страницата и пробвайте пак",
                    payment_fail: "Плащането е неуспешно, моля опитайте отново или изберете друг метод на плащане",
                    payment_cancelled: "Плащането е отменено, моля, опитайте отново или изберете друг метод на плащане",
                    payment_error: "Имахме малък проблем при обработката на онлайн плащането, моля, пробвайте отново или изберете друг метод на плащане",
                    payment_declined: "Нашият доставчик на платежни услуги отхвърли вашето плащане. Използвайте друг метод за плащане",
                    card_declined: "Вашата карта беше отхвърлена и плащането не можа да бъде обработено",
                    promo_max_uses_exceeded: "Този промо код достигна лимита си за използване и вече не е наличен.",
                },
            },
            dish: {
                add: "ДОБАВИ КЪМ ПОРЪЧКАТА",
                edit: "Редактирай",
                notes: "Специални изисквания...",
                ingredients: {
                    title: "Съставки",
                    uncheck_remove: "Премахни съставка, като премахнеш отметката",
                },
                ingredients_title: "Съставки",
                combo: {
                    choose_dish: "Изберете продукт",
                },
                option_sets: {
                    conditions: {
                        select_one: "Изберете само една (Задължително е)",
                        select_one_optional: "Изберете само една (По желание)",
                        select_between: "Изберете между {{min}} - {{max}} (Задължително е)",
                        select_at_least: "Изберете най-малко {{qty}} добавки (Задължително е)",
                        select_up_to: "Изберете най-много {{qty}} добавки (По желание)",
                        select_multiple: "Изберете още продукти (По желание)",
                        free_amount: "Първите {{qty}} са БЕЗПЛАТНИ / {{selected}} Избрани",
                    },
                },
                error: "Моля, обърнете внимание на всички опции, маркирани в червено",
                added_to_cart: "Поръчката е обновена и продукта е добавен към поръчка",
            },
            map: {
                zone_fee: "Цена на доставка",
                view_in_google: "Посочи адреса в Google Maps",
            },
            portal_go_back: {
                title: "Връщане към Търсене на ресторант",
                description: "Всичките артикули добавени за поръчка ще бъдат премахнати",
                cancel: "Отмени",
                proceed: "Разбрах, Продължи",
            },
            order: {
                config: {
                    services: {
                        title: "Избери Услуга",
                        table_booking: "Резервирай маса",
                    },
                    address_custom: {
                        input_placeholder: "Въведи адрес за доставка",
                    },
                    address: {
                        input_placeholder: "Посочи адреса за доставка с Google Maps",
                        extras_placeholder: "По избор: насоки,номер на адрес, име на сграда и т.н.",
                        search_placeholder: "За правилно търсене на адреса, изпиши: улица/бул. 'Име' №, ПК, Град/Село",
                        not_found: "Адреса за доставка не е открит в Google Maps, ако не го откриваш, търси обещствено известен търговски обект до теб като: Happy Bar & Grill, бул. „Александър Стамболийски“ 101, 2, 1303 ж.к. Зона Б-5, София, България",
                        not_delivering: "В момента не доставяме до този адрес",
                        not_in_range: "За съжаление системата ни за доставки отчита, че се намираме далеч от вашия адрес до който все още не са достигнали заведенията ни",
                        not_in_zone: "За съжаление системата ни за доставки отчита, че се намираме далеч от вашия адрес и така не бихме могли да доставим топла и вкусна храна",
                    },
                    datetime: {
                        title: "Кога Искате да Поръчате",
                        due_now: "Сега",
                        due_later: "За По-късно",
                        service_not_available: "За съжаление в момента не приемаме поръчки за {{service}}",
                        currently_closed: "Не приемаме поръчки за {{service}} с изпълнение на момента, но можете да поръчате за по-късно",
                        due_unavailable: "Не е налично",
                        due_closed: "Затворено",
                        select_date: "Избери Дата",
                        select_time: "Избери Час",
                        select_order_date: "Избери дата за изпълнение поръчката",
                        select_order_time: "За колко часа да е готова поръчката?",
                        select_booking_date: "Изберете датата на резервация на маса",
                        select_booking_time: "В колко часа да ви очакваме?",
                        no_times_available: "В този час нямаме налични свободни маси",
                        date_today: "(Днес)",
                        date_closed: "(Не приемаме)",
                        date_bookings_paused: "(Резервациите са спрени)",
                        time_slot_closed: "Не приемаме",
                    },
                    number_of_people: {
                        placeholder: "Брой гости",
                    },
                    table: {
                        select: "Избери Маса",
                        select_popup_title: "Избери Твоята Маса",
                        password: "ПИН код на маса",
                        password_warning: "Въведете уникалния ПИН код на вашата маса, за да изпратите поръчката на бара/кухнята",
                    },
                    warning: {
                        closed: "За съжаление приключихме за днес / не приемаме никакви поръчки",
                        not_available: "В момента не приемаме никакви поръчки",
                    },
                    start_button: "НАЧАЛО НА ПОРЪЧКАТА",
                },
                history: {
                    invalid: "Не отговаря на условията за повторна поръчка, тъй като някои от поръчаните артикули са променени или вече не са налични",
                },
                reorder: {
                    title: "Бърза повторна поръчка",
                    description: "Поръчайте лесно артикулите от предишните си поръчки",
                },
            },
            receipt: {
                errors: {
                    not_found: "Поръчката не открита в нашите записи, обновете страницата и пробвайте отново",
                    booking_not_found: "Резервацията не съществува. Възможно е да е изтрита",
                    generic: "Имахме малък проблем, моля обновете страницата, ако проблема продължава ви молим - сигнализирайте ни за да сме сигурни, че поръчките ви достигат където трябва, както всички искаме",
                },
                connection: {
                    connected: "Наблюдавате в реално време",
                    connecting: "Опит за свързване",
                    disconnected: "Връзката е прекъсната",
                },
            },
            warnings: {
                logout: {
                    pretitle: "Внимание",
                    title: "Изход от профила",
                    body: "Излизането Ви ще премахне всички артикули, които са били добавени за поръчка",
                    cancel: "Отмени",
                    proceed: "Разбирам, изход сега",
                },
                order_restart: {
                    warning: "Внимание",
                    title: "Ще изтриете всичко добавено за поръчване",
                    body: "С това действие ще рестартирате отначало цялата си поръчка тъй като ще премахнете всички продукти добавени до момента за поръчване, тъй като и някои ястия/напитки са свързани с други артикули",
                    cancel: "Отмени",
                    proceed: "Разбирам, продължи",
                },
                order_expired: {
                    subtitle: "Важно",
                    title: "Поръчката е променена на дължима незабавно",
                    description: "Времето за изпълнение на вашата поръчка, почти ще изтече. Поради това поръчката ви е променена за да бъде изпълненена Незабавно / Възможно най-скоро",
                    button: "Разбирам, чакам",
                },
                order_expiring: {
                    subtitle: "Важно",
                    title: "Крайният срок за поръчката ви изтича скоро",
                    description: "Вашата поръчка ще бъде готова след {{time, timeFromTimestamp}} в противен случай статуса на поръчката ще бъде променен автоматично като неизпълнена в срок по наша вина, Вие пак ще получите поръчката си.",
                    button: "Разбирам, чакам",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "Гост",
                login: "Вход",
                login_signup: "Вход / Регистрация",
                logout: "Изход",
            },
            menus: {
                info: {
                    no_menus: "В момента няма налични менюта",
                    restrictions: "Правила на Менюто",
                    not_available: "Менюто в момента не е налично",
                    unavailable: {
                        times: "Правилата за това меню не позволяват вашата поръчка да се изпълни поради това, че поръчката ви е заявена за час на изпълнение извън часа определен за приготвяне на това менюто. Виж правила по-горе",
                        services: "Правилата за това меню не позволяват поръчката ви да бъде изпълнена поради това, че е заявена в комбинация с избраната услуга - която не е определена с това меню. Виж правила по-горе",
                        hours: "Правилата за това меню не позволяват вашата поръчка да бъде направена извън рамките на часовите менюта. Виж правила по-горе",
                        pre_order: "Правилата за това меню, не позволяват предварителни поръчки. Виж правила",
                        age: "Правилата за това меню изискват да сте влезли с профила си с потвърдена възраст, за да поръчате от това меню. Виж правилата по-горе",
                    },
                    services: {
                        title: "Изисквания за поръчка",
                        pickup: "Ще Взема сам",
                        delivery: "С Доставка",
                        dine_in: "Поръчка до маса",
                    },
                    times: {
                        now: "Без предварителни поръчки",
                        later: "Само с предварителни поръчки",
                    },
                    hours: {
                        title: "Часове със Свободни маси",
                    },
                    preorder: {
                        title: "Изисквания за предварителна поръчка",
                        days_in_advance: "Трябва да се поръча {{days}} дни по-рано",
                        cutoff_time: "Краен час на последния ден изтича в {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Ограничения за години",
                        approved: "Вашият акаунт е потвърден успешно и вече можете да поръчате от това меню",
                        rejected: "Изисква се проверка на възрастта за допустимост на този артикул за поръчка. Създайте акаунт и качете свой документ за самоличност. Ние сме регистрирани по ЗЗЛД съгласно Регламент ЕС 2016/679 за GDPR",
                    },
                },
            },
            info: {
                location: {
                    title: "Местоположение",
                    view_map: "Виж на Картата",
                    phone: "Телефон за информация",
                },
                hours: {
                    title: "Работно време",
                    title_special: "Нощно работно време",
                },
                services: {
                    title: "Услуги",
                    notes: "Бележки / Специални изисквания",
                    delivery: {
                        ranges: "Доставка на Разстояние",
                        zones: "Район на Доставка",
                        view_zones: "Виж обслужвания район на картата",
                        fee: "Цена на доставка",
                        fee_short: 'Такса',
                        fee_varies: "Цената варира при направата на поръчката",
                        min_order: "Минимална Поръчка",
                        min_order_short: 'Мин. пор.',
                        no_min_order: "Няма Изискване за Минимална Поръчка",
                        free_amount: "поръчка с вкл. БЕЗПЛАТКА ДОСТАВКА",
                    },
                },
            },
            contact: {
                title: "Свържете се с нас",
                name: "Име и фамилия",
                email: "И-мейл",
                phone: "Телефонен номер",
                message: "Очакваме те с въпроси за - резервации, поръчки, доставки и проблеми...",
                send: "ГОТОВО, ИЗПРАТИ СЕГА",
                success: "Съобщението беше успешно изпратено",
                error: "Имахме малък проблем и твоето съобщение не успя да се изпрати, опитай отново",
            },
            footer: {
                powered_by: "Подкрепено от",
                terms_and_conditions: "Общи условия и правила",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: "Детайли за резервация",
            details: {
                datetime: "Резервация за",
                number_of_people: "Брой гости",
                placed: "Място",
                updated: "Последно актуализирано",
                notes: "Повод / Специални изисквания",
                name: "Име и фамилия",
                email: "И-мейл",
                phone: "Телефонен номер",
                store_address: "Адрес на заведението",
            },
            status_update: {
                title: "Резервация {{number}} е актуализирана",
                body: "Състоянието на вашата резервация е актуализирано на {{status}}",
            },
            email_status_update_customer: {
                subject: 'Резервация #{{number}} – {{subjectLabel}}',
                body: 'Резервацията ви #{{number}} в {{store}} вече е {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Поръчка #{{number}} – {{subjectLabel}}',
        header: 'Обновено време за готовност',
        title: 'Обновено време за готовност',
        order_number: 'Номер на поръчка: {{number}}',
        description: 'Поръчката ви ще бъде готова в {{time}}.',
        order_time_updated_to: 'Часът на поръчката ви е обновен.',
        powered_by: 'Задвижвани от {{name}}',
        button_text: 'Проследяване на поръчка',
        subject_label: 'Обновено време за готовност',
        subject_label_delivery: 'Обновено време за доставка',
        body_ready: 'Поръчката ви ще бъде готова в {{time}}.',
        body_delivery: 'Поръчката ви ще бъде доставена в {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: "Очаквано време за готовност",
            est_driver_pickup_time: "Очаквано време за вземане на доставката",
            est_delivery_time: "Очаквано време за доставка",
            tab_details: "Детайли",
            tab_dishes: "Артикули",
            details: {
                status: "Статус",
                placed: "Заявена на",
                due: "Изпълнение",
                due_asap: "Сега / Възможно по-скоро",
                last_updated: "Последна актуализация",
                total: "Общо за плащане",
                type: "Вид",
                table: "Маса",
                number_of_people: "Брой гости",
                payment_method: "Метод за плащане",
                payment_status: "Статус на плащане",
                payment_currency: "Валута на плащане",
                notes: "Бележки",
                name: "Име и фамилия",
                email: "И-мейл",
                phone: "Телефонен номер",
                distance: "Разстояние",
                driving_time: "Време за доставка",
                delivery_zone: "Район за доставка",
                delivery_address: "Адрес за доставка",
                delivery_tracking: "Проследяване на доставката",
                delivery_tracking_link: "Проследи доставката сега",
                tookan_status: "Tookan Статус",
                tookan_status_failed_book: "Неуспешно резервиране на доставка",
                tookan_status_failed_update: "Неуспешно актуализиране на резервацията",
                tookan_status_success: "Резервиран за доставка",
                store_address: "Адрес на заведението",
            },
            dishes: {
                headings: {
                    quantity: "Брой",
                    item: "Артикули",
                    price: "Цена",
                },
                notes: "Повод / Специални изисквания",
                remove_ingredients: "Премахване на съставките",
            },
            status_update: {
                title: "Поръчка {{number}} актуализирана",
                body: "Състоянието на вашата поръчка е актуализирано на {{status}}",
            },
            wait_time_update: {
                title: "Поръчка {{number}} актуализирана",
                body: "Крайният срок за изпълнение на поръчката е актуализиран",
            },
            delivery_update: {
                title: "Поръчка {{number}} актуализирана",
                body: "Вашата поръчка е резервирана за доставка. Вижте връзката за проследяване на доставката в реално време",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) вкл. в цената",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Цена на доставка",
            promo: "Отстъпка: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "Отстъпка: {{name}} ({{percent}}%)",
            promo_fixed: "Отстъпка: {{name}}",
            promo_none: "Отстъпка: {{name}}",
            cart: "Стойност на поръчката",
            tip: "Оставен бакшиш",
            total: "ОБЩА СУМА ЗА ПЛАЩАНЕ",
        },
        status: {
            unconfirmed: "Не Потвърдена",
            confirmed: "Потвърдена",
            ready: "Готова",
            on_route: "На Път",
            complete: "Завършена",
            cancelled: "Отменена",
            seated: "Настанени",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Недостъпно",
                },
            },
            dish: {
                no_stock: "Изчерпано",
                not_available: "Не е налично",
            },
        },
    },
};
//# sourceMappingURL=bg.js.map